"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _constants = require("../secondary-nav/constants");
var _context = require("../context");
var _layout = require("../layout");
var _propTypes = require("../prop-types");
var _core = require("@emotion/core");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var FixedContainerBase = ( /*#__PURE__*/0, _styledBase.default)(_layout.View, {
  target: "ey9hjii0"
})(process.env.NODE_ENV === "production" ? {
  name: "ttnbja",
  styles: "position:fixed;top:0;left:0;width:100%;"
} : {
  name: "ttnbja",
  styles: "position:fixed;top:0;left:0;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var FixedContainer = function FixedContainer(_ref) {
  var children = _ref.children,
    offset = _ref.offset;
  var _useContext = (0, _react.useContext)(_context.StencilContext),
    selectors = _useContext.selectors;
  var PAGE_HEADER_AND_SECONDARY_NAV_HEIGHT = _constants.SECONDARY_NAV_HEIGHT + selectors.constant('headerHeight');
  if (offset === undefined) offset = PAGE_HEADER_AND_SECONDARY_NAV_HEIGHT;
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(FixedContainerBase, null, children), (0, _core.jsx)(_layout.Spacer, {
    height: offset
  }));
};
FixedContainer.displayName = 'FixedContainer';
var FixedContainerWithDocs = (0, _stencilReactDesc.describe)(FixedContainer).description('Fixed container used to group elements, by default set up for PageHeader and SecondaryNav.');
FixedContainerWithDocs.propTypes = {
  offset: (0, _propTypes.cssValue)().description('Sets in-page padding to account for fixed elements. Should be equal to the height of children.')
};
var _default = FixedContainerWithDocs;
exports.default = _default;